<template>
<productProgress
  title="产品主页"
/>
</template>

<script>
import productProgress from './productProgress';

export default {
  name: 'homeProducts',
  components: {
    productProgress
  }
};
</script>

<style scoped lang="scss">
</style>
